import React, { useContext, useEffect, useState } from 'react';
import { Button, Space } from 'antd';
import { useParams } from 'react-router-dom';
import { ItemService, Title } from '../../services/Item';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import './menuOrder.css'
import { ItemsContext } from '../../layout/itemContext/itemContext';

const MenuOrder: React.FC = () => {

    const params = useParams();
    const [titles, setTitles] = useState<Title[]>([]);
    const { getTitles } = useContext(ItemsContext);

    useEffect(() => {
        const country = params.country;
        const getTitles = async () => {
            const { data } = await ItemService.getTitles(country!);
            setTitles(data);
        }

        getTitles()

    }, [])

    const move = (from: number, to: number) => {
        const result = [...titles];
        let temp = result[from];
        result[from] = result[to];
        result[to] = temp;
        setTitles(result)
    }

    const moveSubtitle = (title: number, from: number, to: number) => {
        const result = [...titles];
        let temp = result[title].children[from];
        result[title].children[from] = result[title].children[to];
        result[title].children[to] = temp;
        setTitles(result)
    }

    const handleOrderMenu = async () => {
        try {
            await ItemService.orderMenu(titles)
            await getTitles(true);
        } catch (e) {
            console.log(e)
        }
    }

    return (
        <div className='menu-order'>
            {titles.map((item, index) => <div className='item-title-wrap'>
                <div className='item-title'>
                    {item.title}
                    <Space>
                        {index !== 0 && <ArrowUpOutlined onClick={() => move(index, index - 1)} />}
                        {index != titles.length - 1 && <ArrowDownOutlined onClick={() => move(index, index + 1)} />}
                    </Space>
                </div>
                <div className='subtitles'>
                    {item.children.map((subtitle, index2) => <div className='item-subtitle'>
                        {subtitle.title}
                        <Space style={{ paddingLeft: 8 }}>
                            {index2 !== 0 && <ArrowUpOutlined onClick={() => moveSubtitle(index, index2, index2 - 1)} />}
                            {index2 != item.children.length - 1 && <ArrowDownOutlined onClick={() => moveSubtitle(index, index2, index2 + 1)} />}
                        </Space>
                    </div>)}
                </div>
            </div>)}
            <Button onClick={handleOrderMenu} type='primary'>Save</Button>
        </div>
    )
};

export default MenuOrder;